export const VISITED_NEW_BADGES_KEY = 'visitedNewBadges';
export const SHOW_ACCOUNT_CREATED_MESSAGE_KEY = 'showAccountCreatedMessage';
export const BOLT_STAR_ONBOARDING_DIALOG_DISMISSED_KEY = 'boltStarOnboardingDialogDismissed';
